import { DocTop } from '@/components/shell/DocTop';
import { Section } from '@/components/ui/Section';
import { Pill } from '@/components/ui/Pill';
import { useWallet } from '@/lib/walletHooks';
import { useMe } from '@/lib/useMe';
import { canSeeBilling } from '@/lib/permissions';
import { formatCurrencyEurRo } from '@/lib/format';
import { CostPerMapare } from './CostPerMapare';
import { RegistruCredite } from './RegistruCredite';
import { SesiuniInstanta } from './SesiuniInstanta';
import { UsageChart } from './UsageChart';

export function UtilizarePage() {
  const { data: me } = useMe();
  const { data: w, isPending, isError } = useWallet();
  const billing = canSeeBilling(me);
  return (
    <>
      <DocTop />
      <div className="mt-8 space-y-10">
        <div>
          <h1 className="text-[32px] font-[650] text-ink">Utilizare</h1>
          <div className="mt-1 border-b-2 border-ink pb-3" />
        </div>

        {!billing ? (
          <div className="py-10 text-center">
            <p className="text-[15px] font-semibold text-ink-3">Secțiune disponibilă administratorilor</p>
            <p className="mt-2 text-[13.5px] text-ink-3">
              Datele de utilizare și costuri sunt vizibile administratorilor organizației.
            </p>
          </div>
        ) : (
          <>
            <Section title="Sold">
              {isPending && <div className="h-[92px] animate-pulse rounded-2xl bg-wash" aria-hidden />}
              {isError && <p className="text-[13.5px] text-bad">Nu s-a putut încărca soldul.</p>}
              {/* No derived "consumat": monthlyEur − balanceEur misrepresents usage once a
                  manual credit grant (operator console) lifts the balance outside the monthly
                  cycle — it can even go negative. Actual consumption is shown accurately below
                  in Registru credite / Cost per mapare / the 30-day usage chart. */}
              {w && (
                <div>
                  <span className="block text-[11.5px] font-medium uppercase tracking-[0.06em] text-ink-3">Sold curent</span>
                  <div className="mt-1 flex flex-wrap items-baseline gap-x-3 gap-y-1.5">
                    <span className="text-[40px] font-bold leading-none tracking-tight tabular-nums text-ink">
                      {formatCurrencyEurRo(w.balanceEur)}
                    </span>
                    {w.autoRefill && <Pill variant="accent">Realimentare automată (pilot)</Pill>}
                  </div>
                  <p className="mt-2 text-[13.5px] text-ink-2">
                    Inclus lunar <span className="font-medium tabular-nums text-ink-2">{formatCurrencyEurRo(w.monthlyEur)}</span> · se
                    reînnoiește pe data de <span className="font-medium tabular-nums text-ink-2">{w.resetDay}</span>
                  </p>
                </div>
              )}
            </Section>

            <Section title="Registru credite"><RegistruCredite /></Section>
            <Section title="Sesiuni instanță"><SesiuniInstanta /></Section>
            <Section title="Cost per mapare"><CostPerMapare /></Section>
            <Section title="Utilizare — ultimele 30 de zile"><UsageChart /></Section>
          </>
        )}
      </div>
    </>
  );
}
